import { useQuery } from "@tanstack/react-query";
import { api } from "./client";

export interface Me {
  id: number;
  username: string | null;
  first_name: string | null;
  language_code: string | null;
  is_admin: boolean;
  plan_id: string | null;
  plan_expires_at: string | null;
  trial_granted: boolean;
  news_verified: boolean;
  referral_balance_usd: number;
  referral_total_earned_usd: number;
  total_sent_messages: number;
}

export function useMe() {
  return useQuery({
    queryKey: ["me"],
    queryFn: () => api.get<Me>("/auth/me"),
    staleTime: 5 * 60_000,
    retry: 1,
  });
}
